var Constants = require('../constants/Constants');
var BaseStore = require('./BaseStore');

var ContactStore = new BaseStore({
    defaultData: []
});

ContactStore._working = false;
ContactStore.getRelFor = function (id) {
  id = parseInt(id, 10)
  const data = this.get()
  const found = data.find(rel => rel.user.id === id)

  return found
}

ContactStore.register(Constants.auth_api.AUTH, function (payload) {
  var action = payload.action;

  // The work for this request occurs in ClientStore.

  if (action.state === Constants.request.PENDING) {
    this._working = action.actionType;

    return true;
  }

  if (action.state === Constants.request.TIMEOUT) {
    this._working = null;

    return true;
  }

  if (action.state === Constants.request.FINISHED) {
    this._working = null;

    return true;
  }
})

ContactStore.register(Constants.auth_api.DEAUTH, function (payload) {
  var action = payload.action;

  if (action.state === Constants.request.PENDING) {
    this._working = action.actionType;

    return true;
  }

  if (action.state === Constants.request.FINISHED) {
    this._working = null;

    const rels = this.get()

    this.setData(rels.filter(rel => rel.user.email !== action.params.username))

    return true;
  }
})

ContactStore.register(Constants.auth_api.MODIFY_AUTH, function (payload) {
  var action = payload.action;

  if (action.state === Constants.request.PENDING) {
    this._working = action.actionType;

    return true;
  }

  if (action.state === Constants.request.FINISHED) {
    this._working = null;

    return true;
  }
})

ContactStore.register(Constants.api.GET_SERVICES, function (payload) {
    var action = payload.action;

    if (action.state === Constants.request.PENDING) {
        this._loading = true;

        return true;
    }

    if (action.state === Constants.request.FINISHED) {
        this._loading = false;

        const rels = action.response.body.client.relationships || []
        rels.sort((a, b) => (a.user.first_name + a.user.last_name).localeCompare(b.user.first_name + b.user.last_name))
        this.setData(rels);

        return true;
    }
});
module.exports = ContactStore;



// WEBPACK FOOTER //
// ./app/stores/ContactStore.js